import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueI18n)
// i18n
const messages = {
    de: require('./locales/de.json'),
    en: require('./locales/en.json'),
    fr: require('./locales/fr.json'),
    it: require('./locales/it.json'),
    ja: require('./locales/ja.json'),
    nl: require('./locales/nl.json'),
    pl: require('./locales/pl.json'),
    pt: require('./locales/pt.json'),
    sp: require('./locales/sp.json')
}

// Set language based on user browser language
let lang = 'en'
if (sessionStorage.getItem('lang')) {
    lang = sessionStorage.getItem('lang') || 'en'
} else {
    lang = (navigator.language).slice(0, 2).toLowerCase()
    sessionStorage.setItem('userLang', lang)
}

// If an account is defined in localStorage, use account language instead
// const acc = JSON.parse(localStorage.getItem(ACCOUNT))
// if (acc && acc.language && acc.language.iso2) {
//     lang = acc.language.iso2.toLowerCase()
// }

const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'en',
    messages
})

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
